import { React, PropTypes, APIPropTypes, actions, connect } from 'imports';
import { RequestStatus } from 'utils/constants';
import ComponentLoader from '../ComponentLoader/ComponentLoader';
import Typed from 'components/common/Typed/Typed';
import Popup from 'components/common/Popup/Popup';
import FormattedResource from 'typed/components/common/FormattedResource/FormattedResource';
import { omit } from 'utils';
import './Root.less';

class Root extends React.Component {
    static get propTypes() {
        return {
            session: APIPropTypes.SessionInformation.isRequired,
            users: APIPropTypes.networkArrayOf(APIPropTypes.UserLocal).isRequired,
            currentUserCompanyAccesses: APIPropTypes.networkArrayOf(APIPropTypes.UserCompanyAccessReport).isRequired,
            messages: APIPropTypes.networkObjectOf(PropTypes.object).isRequired,
            globalErrorDialog: PropTypes.shape({ isVisible: PropTypes.bool.isRequired }).isRequired
        };
    }

    state = { waitableChildReady: false }

    componentWillMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.session.Custom.status === RequestStatus.UNSYNCED) {
            nextProps.dispatch(actions.loadSession());
        }

        if (nextProps.users.Custom.status === RequestStatus.UNSYNCED) {
            nextProps.dispatch(actions.loadAllUsers());
        }

        if (nextProps.currentUserCompanyAccesses.Custom.status === RequestStatus.UNSYNCED) {
            nextProps.dispatch(actions.loadCurrentUserCompanyAccesses());
        } else if (nextProps.currentUserCompanyAccesses.Custom.status === RequestStatus.SUCCEEDED &&
            nextProps.session.Custom.status === RequestStatus.SUCCEEDED &&
            !nextProps.currentUserCompanyAccesses.Data.some(({ CompanyID }) => CompanyID === nextProps.session.CurrentCompanyID) &&
            !this.props.location.pathname.startsWith('/inactive_company') &&
            !nextProps.location.pathname.startsWith('/inactive_company')
        ) {
            nextProps.dispatch(actions.replace({ pathname: '/inactive_company', query: {...nextProps.location.query, oldPath: nextProps.location.pathname } }));
        }

        if (nextProps.messages.Custom.status === RequestStatus.UNSYNCED) {
            nextProps.dispatch(actions.loadMessages());
        }

        if (this.props.session !== nextProps.session) {
            nextProps.dispatch(actions.push(nextProps.location)); // refresh route to check new access permissions
        }
    }

    _onComponentReady = () => {
        this.setState({ waitableChildReady: true });
    }

    _onCloseGlobalErrorDialog = () => {
        this.props.dispatch(actions.closeGlobalErrorDialog());
    }

    render() {
        let waitableChild = !Array.isArray(this.props.children) ? this.props.children : this.props.children.length === 1 ? this.props.children[0] : null;
        while (waitableChild && typeof waitableChild.type === 'function' && !(waitableChild.type.prototype instanceof React.Component)) {
            waitableChild = waitableChild.type(waitableChild.props);
        }
        if (waitableChild && waitableChild.type !== ComponentLoader) {
            waitableChild = null;
        }
        const everythingLoaded =
            !!this.props.session.UserID &&
            (this.props.users.Custom.status === RequestStatus.SUCCEEDED || !!this.props.users.Data.length) &&
            this.props.currentUserCompanyAccesses.Custom.status === RequestStatus.SUCCEEDED &&
            this.props.messages.Custom.status === RequestStatus.SUCCEEDED &&
            (!waitableChild || this.state.waitableChildReady);

        // TODO this component's pieces are shown untile all of necessary content arrives from the API
        // including current locale and translations, but should there be another way to configure locale and translations for at least couple of lines below
        // from outside, i. e. when the app is nested into some other website?
        return (
            <div className="root">
                {
                    !everythingLoaded ?
                        <div className="loading-screen">
                            <div className="centered">
                                <Typed options={{
                                    strings: ['Get <span class="highlight">right</span> things done<span class="highlight">.</span>'],
                                    loop: true,
                                    contentType: 'html',
                                    typeSpeed: 23,
                                    backSpeed: 2,
                                    backDelay: 988
                                }} />
                            </div>
                        </div> :
                        null
                }

                {
                    waitableChild ?
                        <ComponentLoader {...omit(waitableChild.props, ['children'])} componentVisible={everythingLoaded} spinnerVisible={false} onReady={this._onComponentReady}>
                            {waitableChild.props.children}
                        </ComponentLoader> :
                        this.props.children
                }
                {
                    this.props.globalErrorDialog.isVisible ?
                        <Popup className="global-error-dialog-popup" dimmed={true}>
                            {
                                this.props.globalErrorDialog.message ?
                                    <div className="message">{this.props.globalErrorDialog.message}</div> :
                                    <div className="message">
                                        <p>
                                            <FormattedResource resource={{ id: 'app.application_faced_unhandled_error' }} />
                                        </p>
                                        <p>
                                            <FormattedResource resource={{ id: 'app.this_error_is_reported_to_development_team' }} />
                                        </p>
                                        <p>
                                            <FormattedResource resource={{ id: 'app.avoiding_this_functionality_or_reloading_might_help' }} />
                                        </p>
                                    </div>
                            }
                            <div className="action-buttons">
                                <button onClick={window.location.reload.bind(window.location, false)}><FormattedResource resource={{ id: 'common.button.reload_now' }} /></button>
                                <button className="primary" onClick={this._onCloseGlobalErrorDialog}><FormattedResource resource={{ id: 'common.ok' }} /></button>
                            </div>
                        </Popup> :
                        null
                }
            </div>
        );
    }
}

export default connect(state => ({
    ...state.app
}))(Root);